import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/homepage/ModernHomePage.tsx");
